import { render, staticRenderFns } from "./MobileVerification.vue?vue&type=template&id=8164fd76&"
import script from "./MobileVerification.vue?vue&type=script&lang=js&"
export * from "./MobileVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports